import tw from 'tailwind-styled-components';

export const Container = tw.div`
 bg-white
 shadow-2xl
 rounded-lg
 m-auto
 -mt-24
 w-4/6
 p-12
 pb-1
`;
